<template>
  <div id="News" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 ">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">N</span>otificación</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
        <div class="col-12 bg-color1 pt5 pb5 pl10 pr10 f12">
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':data_status == 0,'color-muted':data_status != 0}" @click="statusCh(0)"> Todas </div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':data_status == 1,'color-muted':data_status != 1}" @click="statusCh(1)"> Leído </div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':data_status == 2,'color-muted':data_status != 2}" @click="statusCh(2)"> No leído </div>
      </div>
    </div>
    <div class="h8"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(notify,notify_i) in data_list" v-bind:key="notify_i">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-1 pt8">
                <i class="iconfont icon-notification f22" :class="notify.status == 1? 'color-primary fw':'color-muted'"></i>
              </div>
              <div class="col-11 pl10" >
                <div class="col-12 f14 el1 pt8" :class="notify.status == 1? 'color-black fw':'color-muted'">{{notify.title}}</div>
                <div class="col-12 f14 pb2 color-muted lh24"> {{notify.body}}</div>
                <div class="col-12 f12 color-muted lh24" v-if="notify.notify_type != 'pos_log'">{{notify.update_time}}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'News',
  data () {
    return {
      data_list: [],
      data_status: 0,
      pageConfigTotal:{total:0,pageSize:20,pageNo:1},
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.status = this.data_status;
      post_data.page = this.data_page;
      this.post(this.api_url + 'manage/account_notify', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.notify;
          this.pageConfigTotal.total = res.data['notify_count'];
        }else{
          this.data_list = []
        }
      })
    },
    status_update(notify_id = 0){
      var post_data = {};
      post_data.notify_id = notify_id;
      this.post(this.api_url + 'manage/account_notify_update', post_data).then((res)=>{
        if(res.status == 1 && notify_id != 0){
          this.get_list_data();
        }
      })
    },
    statusCh(status){
      this.data_status = status;
      this.get_list_data();
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.data_page = page;
      this.get_list_data();
    },
  },
  //页面销毁时
  beforeDestroy() {
    this.status_update();
  },
  components: {
    pageComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/News.vue